export default __webpack_public_path__ + "static/award-expect-7d212cedbb6a51e48b0554b89c4a26c2.png";